import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./components/user/LoginPage";
import PlatformFeatures from "./components/Feature";
// import DigitalTwinViewerInsertion from "./components/DigitalTwinViewerInsertion";
import UserProjectsGrid from "./components/user/UserProjectsGrid";
import DigitalTwinViewerInsertion from "./components/DigitalTwinViewerInsertion";
import ProjectDetailPage from "./components/projects/ProjectDetailPage";
import EnergyDataInsertion from "./components/energy/EnergyDataInsertion";
import SceneSetupInsertion from "./components/SceneSetupInsertion";
import WindowSetup from "./components/WindowSetup";
import AssignToProject from "./components/projects/AssignToProject";
import RegisterUser from "./components/user/RegisterUser";
import VirtualWindComponent from "./components/sensors/VirtualWindComponent";
import CrremComponent from "./components/energy/CrremComponent";
import PVPanelSetup from "./components/energy/PVPanelSetup";
import EnergyConsumptionDashboard from "./components/energy/EnergyConsumptionDashboard";
import DayLightFactorSetup from "./components/energy/DayLightFactorSetup";
import VirtualWholeSensorSetup from "./components/sensors/VirtualWholeSensorSetup";
import TechnicalData from "./components/TechnicalData";
import UserFiles from "./components/user/UserFiles";
import ThermalSe from "./components/ThermalSe";
import UserManagement from "./components/user/UserManagement";
import DeleteUserComponent from "./components/user/DeleteUserComponent";
import WithNavbar from "./components/common/LeftNavbar";
import ProjectManagement from "./components/projects/ProjectManagement";
import NewProjectCreation from "./components/projects/NewProjectCreation";
import ProjectEdit from "./components/projects/ProjectEdit";
import NotificationBadge from "./components/common/NotificationBadge";
import WindRiskComponent from "./components/sensors/WindRiskComponent";
import RoomFootprint from "./components/energy/RoomFootprint";
import CombinedComponent from "./components/CombinedComponent";
import ResetPassword from "./components/user/ResetPassword";
import ProjectProcessing from "./components/execution/ProjectProcessing";
import KMLSetup from "./components/execution/KMLSetup";

import FileManager from "./components/uploads/FileManager";
import ProjectUserList from "./components/projects/ProjectUserList";
import ShadingProgressionUploader from "./components/energy/ShadingProgressionUploader";
import SensorPlacement from "./components/sensors/SensorPlacement";
import ActivityMonitor from "./components/common/ActivityMonitor";
import ExcelUploader from "./components/uploads/ExcelUploader";
import ProjectUpdater from "./components/projects/ProjectUpdater";
import BulkProjectImporter from "./components/uploads/BulkProjectImporter";
import RetrofitAndEnergyComponent from "./components/energy/RetrofitAndEnergyComponent";
import FrontendZipExtractor from "./components/sensors/WindGif";
import TerrainGeneration from "./components/execution/TerrainSetup";
import GeodataSetup from "./components/execution/GeodataSetup";
import CheckOutputFilesPage from "./components/execution/CheckOutputFiles";
import TreeGenerationPage from "./components/execution/TreeVegetation";
import RaytracingConfiguration from "./components/execution/RaytracyingConfig";
import UserProjectsGridNew from "./components/user/ReusableProjectGrid";
import RayTracingExecution from "./components/execution/RaytracyingExecution";
// import RayTracingConfig from "./components/execution/RayTracingConfig";
// import RayTracingConfig from "./components/execution/RayTracingConfig";
const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate replace to="/login" />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/features" element={<PlatformFeatures />} />
        {/* <Route path="/user-projects" element={<UserProjectsGrid />} /> */}
{/* <Route path="/user-projects" element={
  <UserProjectsGridNew
    title="Edit Projects"
    subtitle="Select a project to edit and modify its settings"
    navigateTo="edit"
  />
} />
<Route path="/user-projects" element={
  <UserProjectsGrid 
    title="execute Projects"
    subtitle="Select a project to edit and modify its settings"
    navigateTo="execute"
  />
} /> */}
        <Route
          path="/viewer-insertion"
          element={<DigitalTwinViewerInsertion />}
        />
        <Route path="/project/:projectId" element={<ProjectDetailPage />} />
        <Route
          path="/energy-data/:projectId"
          element={<EnergyDataInsertion />}
        />
        <Route
          path="/scene-setup/:projectId"
          element={<SceneSetupInsertion />}
        />
        <Route
          path="/sensor-placement/:projectId"
          element={<SensorPlacement />}
        />
        <Route path="/window-setup/:projectId" element={<WindowSetup />} />
        <Route path="/assign-projects" element={<AssignToProject />} />

        <Route
          path="/crrem-data-setup/:projectId"
          element={<CrremComponent />}
        />
        <Route path="/pv-panel-setup/:projectId" element={<PVPanelSetup />} />
        <Route
          path="/daylight-setup/:projectId"
          element={<DayLightFactorSetup />}
        />
        <Route
          path="/energy-dashboard-setup/:projectId"
          element={<EnergyConsumptionDashboard />}
        />
        <Route
          path="/virtual-sensor-setup/:projectId"
          element={<VirtualWholeSensorSetup />}
        />
        <Route path="/technical-data/:projectId" element={<TechnicalData />} />
        <Route path="/pure-file-setup/:projectId" element={<UserFiles />} />
        {/* <Route path="/user-management" element={<UserManagement />} /> */}
        <Route path="/project-user-relation" element={<ProjectUserList />} />
        <Route path="/thermal-se" element={<ThermalSe />} />
        <Route path="/notification" element={<NotificationBadge />} />
        <Route path="/delete-user" element={<DeleteUserComponent />} />
        <Route path="/wind-risk/:projectId" element={<WindRiskComponent />} />
        <Route path="/room-footprint/:projectId" element={<RoomFootprint />} />
        <Route path="/room-new/:projectId" element={<CombinedComponent />} />
        <Route path="/user-management" element={<UserManagement />} />
        <Route path="/user-registeration" element={<RegisterUser />} />

        <Route path="/password-reset/:user_id" element={<ResetPassword />} />
        <Route path="/project-management" element={<ProjectManagement />} />
        <Route
          path="/bulk-project-importer"
          element={<BulkProjectImporter />}
        />
        <Route path="/new-project" element={<NewProjectCreation />} />
      
        <Route path="/project-file" element={<ProjectUpdater />} />
        <Route
          path="/virtual-wind/:projectId"
          element={<VirtualWindComponent />}
        />
        <Route
          path="/modernization/:projectId"
          element={<RetrofitAndEnergyComponent />}
        />
        <Route
          path="/energy-dashboard-setup/:projectId"
          element={<EnergyConsumptionDashboard />}
        />

       
        <Route path="/kml-setup/:projectId" element={<KMLSetup />} />
        <Route path="/geo-data-setup/:projectId" element={<GeodataSetup />} />
        {/* <Route path="/raytracing-config" element={<RayTracingConfig />} /> */}
        <Route path="/file-manager/:projectId" element={<FileManager />} />

        <Route
          path="/energy-data/:projectId"
          element={<EnergyDataInsertion />}
        />
        <Route
          path="/shading-progression/:projectId"
          element={<ShadingProgressionUploader />}
        />
        <Route path="/wind-gif/:projectId" element={<FrontendZipExtractor />} />
        <Route path="/raytracying-execution/:projectId" element={<RayTracingExecution />} />

        <Route path="/activity-monitor" element={<ActivityMonitor />} />
        <Route path="/excel-uploader" element={<ExcelUploader />} />
        <Route path="/terrain-setup" element={<TerrainGeneration />} />
        <Route path="/check-output-files/:projectId" element={<CheckOutputFilesPage />} />
        <Route path="/tree-vegetation/:projectId" element={<TreeGenerationPage />} />
        <Route path="/raytracying-config/:projectId" element={<RaytracingConfiguration />} />
        <Route path="/user-projects" element={<UserProjectsGridNew />} />
          <Route path="/project-edit/:projectId" element={<ProjectEdit />} />
          <Route path="/project-processing/:projectId" element={<ProjectProcessing />}
          
        />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
